<div
    role="dialog"
    class="fundraiser-modal-container"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-labelledby]="modalTitleId"
    aria-modal="true"
    (keydown.escape)="closeModal()"
>
    <button #closeButton type="button" class="button-undecorated button-close" (click)="closeModal()"
        [attr.aria-label]="'Close ' + fundraiser().name + ' modal'"
        cdkFocusInitial>
        <cwo-icon [name]="iconNameType.close" [size]="'1.25rem'" class="close-icon" aria-hidden="true" />
    </button>
    <div class="fundraiser-modal-header">
        <h2 class="title" [attr.id]="modalTitleId"> {{fundraiser().name}} </h2>
        <p class="description" [attr.id]="modalDescId"> {{fundraiser().description}} </p>
    </div>

    <div class="fundraiser-modal-body" role="region" [attr.aria-label]="'Sponsors for ' + fundraiser().name">
        <div class="sponsor-label-wrapper">
            <span class="sponsor-label"> {{ fundraiser().sponsorLabel ?? 'Sponsor' }} </span>
            @if(requiredError) {
                <span class="sponsor-required" role="alert" [attr.aria-live]="'assertive'" aria-atomic="true">
                    <span class="icon-wrapper" aria-hidden="true">!</span>
                    {{ 'Required' }}
                </span>
            }
        </div>
        @if(fundraiser().sponsors?.length) {
            <ul class="column-content-wrapper" role="list">
                @for (sponsor of fundraiser().sponsors; track $index) {
                    <li role="listitem" [class.has-instructions]="existsInSelectedSponsors(sponsor) && fundraiser().notesEnabled">
                        <cwo-fundraiser-sponsor-entry [sponsor]="sponsor" [selected]="existsInSelectedSponsors(sponsor)" (sponsorToggled)="onSponsorToggled($event)" />
                        @if(existsInSelectedSponsors(sponsor) && fundraiser().notesEnabled) {
                            <cwo-special-instructions-accordion
                                [ariaLabel]="fundraiser().noteLabel?.length  ? (fundraiser().noteLabel ?? '') : 'Add Note'"
                                [labelColor]="'var(--primary-dark)'"
                                [title]=" fundraiser().noteLabel?.length  ? (fundraiser().noteLabel ?? '') : 'Add Note'"
                                [showAlwaysExpandButton]="true"
                                [removeBorder]="true"
                                [maxLength]="50" 
                                (instructionsChanged)="onInstructionsChange($event, sponsor)"
                                [itemInstructionsExpanded]="true"
                                [description]="selectedSponsorNotes(sponsor)"
                            />
                        }
                    </li>
                }
            </ul>
        }
    </div>

    <div class="fundraiser-modal-footer">
        <button type="button" class="button-accent button-add" 
            cwoAsyncButton 
            [subscription]="loadingSubscription" 
            [loadingText]="!isFundraiserApplied() ? 'Add...' : 'Update...'" 
            [attr.aria-label]="!isFundraiserApplied() ? 'Add to order' : 'Update fundraiser'"
            (click)="!isFundraiserApplied() ? addToOrder() : updateFundraiser()"
        >
            {{ !isFundraiserApplied() ? 'Add' : 'Update' }}
        </button>
    </div>
</div>